import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes"

export interface IBusinesses {
    business_id: string;
    moderation: boolean
}

export interface IAddEmployeeData {
    email: string;
    first_name: string;
    last_name: string;
    password: string;
    skip_invite: boolean;
    info: string;
    all_businesses: boolean;
    businesses?: IBusinesses[];
    add_business_ids?: string[];
    remove_business_ids?: string[];
    employee_id?: string;
}

export interface IBlockMember {
    business_id: string,
    employee_id: string
}
export interface IModerationMember {
    business_id: string,
    employee_id: string
}

export interface IVerifyEmployee {
    email: string;
    password: string | null;
    token: string;
}

export const GetTeamsApi = async (business_id: string) => {
    const response = await AxiosInstance.post(apiRoutes?.getteams, { business_id })
    return response
}

export const employeePaginatedApi = async (payload: { business_id: string, page: number, limit: number, keyword: string, sort_by?: string, sort_order?: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.employeePaginated, payload)
    return response
}

export const addEmployeeApi = async (payload: IAddEmployeeData) => {
    const response = await AxiosInstance.post(apiRoutes?.addEmployee, payload)
    return response
}
export const editEmployeeApi = async (payload: IAddEmployeeData) => {
    const response = await AxiosInstance.post(apiRoutes?.editEmployee, payload)
    return response
}

export const verifyEmployeeApi = async (payload: IVerifyEmployee) => {
    const response = await AxiosInstance.post(apiRoutes?.verifyEmployee, payload)
    return response
}
export const blockMemberApi = async (payload: IBlockMember) => {
    const response = await AxiosInstance.post(apiRoutes?.blockMember, payload)
    return response
}
export const moderationApi = async (payload: IModerationMember) => {
    const response = await AxiosInstance.post(apiRoutes?.moderationMember, payload);
    return response;
};

export const deleteEmployeeApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteEmployee, payload);
    return response;
};

export const reinviteEmployeeApi = async (employee_id: string) => {
    const response = await AxiosInstance.post(apiRoutes?.reinviteEmployee, { employee_id });
    return response;
}

export const resetEmployeePasswordApi = async (payload: { employee_id: string, new_password: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.resetEmployeepassword, payload);
    return response;
}

export const toggleAdminRoleApi = async (payload: { employee_id: string, business_id: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.toggleAdminRole, payload);
    return response;
}

